import styled from 'styled-components';

export const PageHeader = styled.div`
  min-height: 10.6rem;
  width: 100%;

  background: #242424;

  padding: 0 5.6rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
`;

export const PageHeaderBackButton = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 25px;
  align-items: center;
  justify-content: center;
  color: #ffdf22;
  cursor: pointer;
`;

export const PageHeaderBackButtonLabel = styled.div`
  font-weight: bold;
  padding-left: 5px;
  text-transform: uppercase;
  letter-spacing: 1.25px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const HeaderButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  gap: 1.5rem;

  font-size: 0px;

  display: flex;
  flex-direction: column;
  justify-content: space-around;

  margin: 0.8rem 0;

  > a,
  button {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    color: #fff;

    padding: 0.4rem;

    border-radius: 0.2rem;

    transition: ${({ theme }) => theme.transition.default};

    :hover {
      transform: scale(1.05);
    }

    :active {
      transform: scale(0.99);
    }

    :first-child {
      background: transparent linear-gradient(155deg, #ffdf22 0%, #ffd503 100%);
    }

    :last-child {
      background: transparent linear-gradient(155deg, #ffdf22 0%, #ffd503 100%);
    }
  }

  @media (min-width: 425px) {
    > a,
    button {
      border-radius: 50%;
    }
  }

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: baseline;

    margin: 0;

    > a,
    button {
      min-width: 3.3rem;
      min-height: 3.3rem;
    }

    > button {
      margin-top: 0rem;
      margin-left: 1.6rem;
    }
  }
`;

export const Container = styled.section`
  margin: 3.6rem 5.6rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 60rem;

  gap: 4.6rem 0;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 425px) {
    gap: 2rem 0;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Content = styled.div`
  @media (max-width: 768px) {
    display: flex;
    flex-direction: row;
    margin-bottom: 2rem;
  }
`;

export const ContentTitle = styled.strong`
  color: #fff;
  font-size: 1.8rem;

  @media (max-width: 768px) {
    padding-right: 5px;
  }
`;

export const ContentValue = styled.p`
  color: #fff;
  font-size: 1.8rem;
`;
